import React from 'react';
import './DailyDarshan.css';
import templeImg from "../assets/temple.webp"

const WHATSAPP_CHANNEL_LINK = 'https://whatsapp.com/channel/0029Va9jFohEVccPnwkPAJ46';

const DailyDarshan = () => {
  return (
    <div className="daily-darshan-container">
      <div className="darshan-channel-card">
        <div className="channel-header">
          <img
            src={templeImg} alt="ISKCON Ujjain"
            className="channel-avatar"
          />
          <div className="channel-info">
            <h2 className="channel-name">ISKCON Ujjain Official</h2>
            <p className="channel-meta">WhatsApp Channel</p>
          </div>
        </div>

        <div className="channel-body">
          <p className="channel-description">
            Get daily darshan photos, aarti updates, and temple announcements
            straight from ISKCON Ujjain — directly on WhatsApp.
          </p>
          <ul className="channel-highlights">
            <li>📷 Daily darshan photo updates</li>
            <li><span role="img" aria-label="folded hands">🙏</span> Aarti & event announcements</li>
            <li>📿 Festival and calendar reminders</li>
          </ul>
        </div>

        <a
          href={WHATSAPP_CHANNEL_LINK}
          target="_blank"
          rel="noopener noreferrer"
          className="follow-channel-button"
        >
          Follow Channel
        </a>

        <p className="channel-footnote">
          Opens WhatsApp. No account changes — you just follow the channel.
        </p>
      </div>
    </div>
  );
};

export default DailyDarshan;
// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import './DailyDarshan.css';
// import { LazyLoadImage } from 'react-lazy-load-image-component';

// const PAGE_ID = '558897874237465';
// const ACCESS_TOKEN = 'EAAOOmhTRAXcBPCpZBtsllp4uyhPQztFXIGMffyk5SPhxbaZCDAsOOoWSg9gOjxZA1PLgMsneSj7DQPt7H9UipaV5QZCP5RLIjxuMq5lbsZB1ygsqR9mTOSsqgRgVSDZA1MtJ1ZBFAeUJqkHTht5YhQY0sjH67vlbQBzqG1UvJH7lhZB14U9ZC1UyWUXowy6zWZAeFbHKYVwWFYrRx7';
// const CACHE_KEY = 'darshan_albums_cache';
// const CACHE_EXPIRY = 1000 * 60 * 60 * 2; // 2 hours in milliseconds

// const DailyDarshan = () => {
//   const [albums, setAlbums] = useState([]);
//   const [error, setError] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [selectedImage, setSelectedImage] = useState(null);

//   const fetchAlbumsAndPhotos = async () => {
//     setLoading(true);
//     try {
//       const res = await axios.get(
//         `https://graph.facebook.com/v19.0/${PAGE_ID}`,
//         {
//           params: {
//             fields: `albums.since(1713147900).limit(10){id,name,photos.limit(5){images,created_time}}`,
//             access_token: ACCESS_TOKEN,
//           },
//         }
//       );

//       const albumData = res.data.albums?.data || [];

//       const albumsWithPhotos = await Promise.all(
//         albumData.map(async (album) => {
//           try {
//             const photoRes = await axios.get(
//               `https://graph.facebook.com/v19.0/${album.id}/photos`,
//               {
//                 params: {
//                   fields: 'images,created_time',
//                   access_token: ACCESS_TOKEN,
//                 },
//               }
//             );

//             return {
//               ...album,
//               photos: photoRes.data.data,
//             };
//           } catch {
//             return { ...album, photos: [] };
//           }
//         })
//       );

//       // Save to localStorage
//       const cacheData = {
//         data: albumsWithPhotos,
//         timestamp: Date.now(),
//       };
//       localStorage.setItem(CACHE_KEY, JSON.stringify(cacheData));

//       setAlbums(albumsWithPhotos);
//     } catch (err) {
//       setError('Failed to load albums.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     const loadFromCache = () => {
//       const cached = localStorage.getItem(CACHE_KEY);
//       if (cached) {
//         try {
//           const parsed = JSON.parse(cached);
//           const isFresh = Date.now() - parsed.timestamp < CACHE_EXPIRY;

//           if (isFresh && Array.isArray(parsed.data)) {
//             setAlbums(parsed.data);
//             return true;
//           }
//         } catch {
//           localStorage.removeItem(CACHE_KEY);
//         }
//       }
//       return false;
//     };

//     const shouldFetch = !loadFromCache();
//     if (shouldFetch) {
//       fetchAlbumsAndPhotos();
//     }
//   }, []);

//   return (
//     <div className="daily-darshan-container">
//       <h2 className="text-center mb-6"><span role="img" aria-label="camera">📷</span> Daily Darshan</h2>

//       {error && <p className="text-red-600 text-center">{error}</p>}
//       {loading && <p className="text-center text-gray-500">Loading albums...</p>}

//       {albums.map((album) => (
//         <div key={album.id} className="album-section">
//           <h3 className="album-title">{album.name}</h3>
//           <div className="darshan-grid">
//             {album.photos?.map((photo, i) => (
//               <div key={i} className="darshan-card">
//                 <LazyLoadImage
//                   src={photo.images[0].source}
//                   alt={`Darshan ${album.name} ${i + 1}`}
//                   effect="blur"
//                   onClick={() => setSelectedImage(photo.images[0].source)}
//                   className="darshan-image"
//                 />
//               </div>
//             ))}
//           </div>
//         </div>
//       ))}

//       {selectedImage && (
//         <div className="zoom-overlay" onClick={() => setSelectedImage(null)}>
//           <span className="close-button" onClick={() => setSelectedImage(null)}>×</span>
//           <img className="zoomed-image" src={selectedImage} alt="Zoomed" />
//         </div>
//       )}

//       {!loading && albums.length === 0 && (
//         <p className="text-center text-gray-500">No albums found.</p>
//       )}
//     </div>
//   );
// };

// export default DailyDarshan;
